import { UPBlogWithDetails, UPBlogWithNoDetails } from 'modules/blogs/types';
import { RootState } from 'store';

export const blogsSelector = (state: RootState): UPBlogWithNoDetails[] => state.blog.blogs;
export const blogToEditSelector = (state: RootState): UPBlogWithDetails => state.blog.blogToEdit;
export const dashboardBlogSelector = (state: RootState): UPBlogWithNoDetails[] => state.blog.dashboardBlogs;

export const blogsLoadingSelector = (state: RootState): boolean => state.blog.loading;
